import { SlotGameType1_21 } from '../SlotGameType1_21';

export class BurningFruits1021 extends SlotGameType1_21
{
}
